import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { IBusinessState, IHom0201PState, IInquiryCndsState } from '../../models/hom/hom0201p_model';
  
const initialState: IHom0201PState = {
    businessList : [],      // 사업장목록

    inquiryCnds: {
        instNm: '',         // 사업장명
    },                      // 조회조건

    pageSize : 20,          // 페이징사이즈
    current : 0,            // 현재페이지
}

export const hom0201p_Slice = createSlice({
    name: "hom0201p_Slice",
    initialState: initialState,
    reducers: {
        initState: (state) => {
            Object.assign(state, {...initialState});
        },
        setBusinessList: (state, action:PayloadAction<IBusinessState[]>) => {
            state.businessList = action.payload;
        },
        setInquiryCnds: (state, action:PayloadAction<IInquiryCndsState>) => {
            state.inquiryCnds = action.payload;
        },
        setPageSize: (state, action:PayloadAction<number>) => {
            state.pageSize = action.payload;
        },
        setCurrent: (state, action:PayloadAction<number>) => {
            state.current = action.payload;
        },
    },
});

export default hom0201p_Slice.reducer;
export const Hom0201pAction  = hom0201p_Slice.actions;
export const Hom0201pReducer = hom0201p_Slice.reducer;